import React from 'react';
import { Typography } from '@mui/material';
import { colors } from 'theme/colors';
import { StyledWrapper } from './styles';

export enum EChipsVariants {
  primary = 'primary',
  success = 'success',
  warning = 'warning',
  error = 'error',
  inactive = 'inactive',
}

export interface IChips {
  text: string | undefined;
  variant?: EChipsVariants;
  className?: string;
  onClick?: (...args: any) => void;
  id?: string;
  textId?: string;
  fullWidth?: boolean;
}

export const Chips = ({
  text,
  variant = EChipsVariants.success,
  className = '',
  onClick = () => {},
  id,
  textId,
  fullWidth = false,
}: IChips) => {
  let backgroundColor: string;
  let textColor: string;
  switch (variant) {
    case EChipsVariants.primary:
      textColor = colors.primary900;
      backgroundColor = colors.primary50;
      break;
    case EChipsVariants.success:
      textColor = colors.success900;
      backgroundColor = colors.success100;
      break;
    case EChipsVariants.warning:
      textColor = colors.warning900;
      backgroundColor = colors.warning100;
      break;
    case EChipsVariants.error:
      textColor = colors.error900;
      backgroundColor = colors.error100;
      break;
    case EChipsVariants.inactive:
      textColor = colors.gray900;
      backgroundColor = colors.gray300;
      break;
    default:
      textColor = colors.primary900;
      backgroundColor = colors.primary50;
  }
  return (
    <StyledWrapper
      id={id}
      fullWidth={fullWidth}
      backgroundColor={backgroundColor}
      onClick={onClick}
    >
      <Typography
        id={textId}
        variant="overline"
        className={className}
        sx={{
          display: 'flex',
          alignItems: 'center',
          lineHeight: '10px',
          letterSpacing: '0.06em',
          textAlign: 'center',
          fontSize: '10px',
          fontWeight: '600',
          color: textColor,
        }}
      >
        {text}
      </Typography>
    </StyledWrapper>
  );
};
